import React from 'react';
export function AnalyticsIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3h-2a2 2 0 00-2 2v14a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2zm0 16h-2V5h2v14zM20 7h-2a2 2 0 00-2 2v10a2 2 0 002 2h2a2 2 0 002-2V9a2 2 0 00-2-2zm0 12h-2V9h2v10zM6 11H4a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2v-6a2 2 0 00-2-2zm0 8H4v-6h2v6z"
  }));
}